import { render, staticRenderFns } from "./DialogRefund.vue?vue&type=template&id=cb2c0022&scoped=true"
import script from "./DialogRefund.vue?vue&type=script&lang=js"
export * from "./DialogRefund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2c0022",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb2c0022')) {
      api.createRecord('cb2c0022', component.options)
    } else {
      api.reload('cb2c0022', component.options)
    }
    module.hot.accept("./DialogRefund.vue?vue&type=template&id=cb2c0022&scoped=true", function () {
      api.rerender('cb2c0022', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/supplyCentreManagement/tradeInquire/components/DialogRefund.vue"
export default component.exports